import type { PlaneAuthorization, PlaneName } from "@/lib/bootstrap-types";

export const PLANE_AUTHORIZATION_SCHEMA =
  "sentinels.plane-authorization/v1" as const;

/**
 * UI convenience only. Unknown/missing/stale projections deny. The backend PDP
 * remains the authority and must re-evaluate every API operation.
 */
export function hasPlaneCapability(
  authorization: PlaneAuthorization | null | undefined,
  plane: PlaneName,
  capability: string,
): boolean {
  if (
    !authorization ||
    authorization.schema !== PLANE_AUTHORIZATION_SCHEMA ||
    authorization.default_effect !== "deny" ||
    authorization.context.failure !== null ||
    !capability.startsWith(`${plane}.`)
  ) {
    return false;
  }

  const planeProjection = authorization.planes[plane];
  if (!planeProjection?.eligible) {
    return false;
  }
  return (
    authorization.global_object_admin ||
    planeProjection.wildcard ||
    planeProjection.capabilities.includes(capability)
  );
}
